module.exports = __webpack_public_path__ + "img/showHow2.821fc637.png";